function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKino = function SvgKino(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 41"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1023.72 1028.76c.13-.03.25-.08.37-.12l1.92 7.18-52.826 14.17-1.915-7.15a.02.02 0 0 0 .023-.01 6.294 6.294 0 0 0-3.254-12.16c-.007 0-.013.01-.021.01l-2.01-7.51 52.823-14.18 2.02 7.53c-.13.03-.26.05-.38.08a6.294 6.294 0 0 0 3.25 12.16",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    transform: "translate(-966 -1009)"
  }));
};
export default SvgKino;